<template>
  <div id="invest-info-drawer">
    <div class="bg-light sticy-top top-0 w-100 position-relative" style="padding-bottom:100px;">
      <b-button variant="light" @click="$emit('closePanel', {closedBy: 'bg'})">
        <close-icon />
      </b-button>
      <div class="wrap py-3 d-inline-block">
        <h6 class="mb-0">About {{ invPackage.packagename }}</h6>
      </div>
    </div>
    <b-col style="margin-top:-100px;">
      <div
        class="dash-card thumb bg-dark shadow-xl bg-cover text-white p-3"
        style="height:150px;"
        :style="{backgroundImage: ` linear-gradient(0deg, rgba(0,0,0,0.6), transparent), url(` + invPackage.imageurl + `)`}"
      >
        <component :is="`${invPackage.slug}-icon`" :size="50"></component>
      </div>
    </b-col>
    <b-col class="mt-4">
      <p>{{ invPackage.description }}</p>
    </b-col>

    <div class="wrap position-fixed bottom-0 p-4">
      <b-button
        v-if="invPackage.status==1"
        variant="primary"
        @click="$emit('closePanel', {invest: true, invPackage: invPackage, closedBy: 'bg'})"
      >Invest</b-button>
      <b-button variant="light" class="ml-2" @click="$emit('closePanel', {closedBy: 'bg'})">Close</b-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    invPackage: null
  }
};
</script>

<style>
</style>